export interface IPlan {
    name: string
    id: string
    base_price: number
    free_spend: number
    interval: number
    rates: { [key: number]: number }
    last_rate: number
}

export interface IPlanCost {
    ad_spend_cost: number
    base_cost: number
    total_cost: number
}

export class Plan implements IPlan {
    name: string = ''
    id: string = ''
    base_price: number = 0
    free_spend: number = 0
    interval: 100 = 100

    last_rate: number = 0
    rates: { [key: number]: number } = {}

    constructor(plan: IPlan) {
        Object.assign(this, plan)
    }

    calculate(adSpend: number): IPlanCost {
        const adSpendCost = this.calculateAdSpendCost(adSpend)
        return {
            base_cost: this.base_price,
            ad_spend_cost: adSpendCost,
            total_cost: this.base_price + adSpendCost,
        }
    }

    private calculateAdSpendCost(adSpend: number): number {
        const rates = { ...this.rates }
        rates[Number.MAX_SAFE_INTEGER] = this.last_rate
        adSpend = Math.floor(adSpend / this.interval) * this.interval
        let extraSpend = adSpend - this.free_spend
        extraSpend = extraSpend < 0 ? 0 : extraSpend

        if (extraSpend == 0) {
            return 0
        }

        let previous = this.free_spend
        let charge = 0
        Object.keys(rates).forEach((spend, index) => {
            const spendI = parseInt(spend)
            const last = index === Object.keys(rates).length - 1
            const rate = rates[parseInt(spend)]
            let chargeAmount = Math.min(spendI - previous, adSpend - previous)
            if (last) {
                chargeAmount = adSpend - previous
            }

            if (adSpend > previous) {
                charge += chargeAmount * (rate / 100)
            }

            previous = spendI
        })

        return Math.round(100 * charge) / 100
    }
}

export enum SubscriptionStatus {
    Incomplete = 1,
    IncompleteExpired = 2,
    Trialing = 3,
    Active = 4,
    PastDue = 5,
    Canceled = 6,
    Unpaid = 7,
}
